<template>
    <div>
        <bs-card class="card-secure" :icon="['fal', 'cog']" :label="$t('labels.' + camelToSnake($options.name))">
            <template v-slot:header>
                <bs-button class="btn-sm btn-secure" @click="create">{{ $t('labels.create_' + camelToSnake(singular($options.name))) }}</bs-button>
            </template>
            <bs-table>
                <tr v-for="r in resources.data" :key="r.id">
                    <th>{{ r.label }}</th>
                    <td class="text-break">{{ r.content }}</td>
                    <td class="t2">
                        <bs-action :icon="['fal', 'pencil']" class="btn-secure" @click="update(r)"></bs-action>
                        <bs-action :icon="['fal', 'trash']" class="btn-danger" @click="destroy(r)"></bs-action>
                    </td>
                </tr>
            </bs-table>
        </bs-card>
        <bs-modal :name="'create-' + $options.name" :label="$t('labels.create_' + camelToSnake(singular($options.name)))">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <tuxedo-input :name="'label'" :label="$t('labels.label')" v-model="resource.label" :error="slotProps.error" />
                    <text-field :name="'content'" :label="$t('labels.content')" v-model="resource.content" :error="slotProps.error"></text-field>
                </template>
            </bs-form>
        </bs-modal>
        <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.destroy_' + camelToSnake(singular($options.name)))">
            <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
                {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
            </bs-form>
        </bs-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ClientGlobal',
  props: ['client'],
  data () {
    return {
      loading: false,
      activeId: null,
      resource: {
        label: '',
        content: ''
      },
      clientData: {
        id: null,
        name: '',
        active: ''
      }
    }
  },
  mounted () {
    this.index(this.page)
  },
  computed: {
    ...mapState({
      resources: state => state.clientGlobal,
      submitting: state => state.submitting
    })
  },
  methods: {
    applySort (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    index () {
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, path: 'ClientSettings', id: this.client, tag: 'global' }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.resource.client = this.client
      this.resource.type = 'global'
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, path: 'ClientSettings', resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, path: 'ClientSettings', id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
